<template>
<div>
  <div class="card">
    <div class="card-body">
      <div class="media">
        <img src="@/assets/images/companies/img-1.png" alt class="avatar-sm me-4" />

        <div class="media-body overflow-hidden">
          <h5 class="text-truncate font-size-15">Skote Dashboard UI</h5>
          <p class="text-muted">Separate existence is a myth. For science, music, sport, etc.</p>
        </div>
      </div>

      <h5 class="font-size-15 mt-4">Project Details :</h5>

      <p
          class="text-muted"
      >To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is. The European languages are members of the same family. Their separate existence is a myth. For science, music, sport, etc,</p>

      <div class="text-muted mt-4">
        <p>
          <i class="mdi mdi-chevron-right text-primary me-1"></i> To achieve this, it would be necessary
        </p>
        <p>
          <i class="mdi mdi-chevron-right text-primary me-1"></i> Separate existence is a myth.
        </p>
        <p>
          <i class="mdi mdi-chevron-right text-primary me-1"></i> If several languages coalesce
        </p>
      </div>

      <div class="row task-dates">
        <div class="col-sm-4 col-6">
          <div class="mt-4">
            <h5 class="font-size-14">
              <i class="bx bx-calendar me-1 text-primary"></i> Start Date
            </h5>
            <p class="text-muted mb-0">08 Sept, 2019</p>
          </div>
        </div>

        <div class="col-sm-4 col-6">
          <div class="mt-4">
            <h5 class="font-size-14">
              <i class="bx bx-calendar-check me-1 text-primary"></i> Due Date
            </h5>
            <p class="text-muted mb-0">12 Oct, 2019</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "DetailsCard"
}
</script>

<style scoped>

</style>
